module.exports = __webpack_public_path__ + "images/settings-a81276fa.svg";